// extracted by mini-css-extract-plugin
module.exports = {"shared":"EJlwN","html":"P3Rs9","structured":"PEcwX","inline-button":"qySag"};